import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {WebSocketCommunityEventName} from "../../../network/socket/names/WebSocketCommunityEventName";
import {arrayRemove} from "../../../sedestral/framework/utilities/ArrayRemove";
import {
    ICommunityArticleOptimizationBatchIncoming
} from "../../../models/community/article/optimizationBatch/ICommunityArticleOptimizationBatchIncoming";
import {
    ICommunityArticleOptimizationBatchCreateIncoming
} from "../../../models/community/article/optimizationBatch/ICommunityArticleOptimizationBatchCreateIncoming";
import {
    ICommunityArticleOptimizationBatchCreateOutgoing
} from "../../../models/community/article/optimizationBatch/ICommunityArticleOptimizationBatchCreateOutgoing";

export class CommunityArticleOptimizationBatchService {

    public static events: ((batch: ICommunityArticleOptimizationBatchIncoming) => void)[] = [];

    public static dispose(): void {
        this.events = [];
    }

    public static init(): void {
        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_ARTICLE_OPTIMIZATION_BATCH_UPDATE, (batch: ICommunityArticleOptimizationBatchIncoming) => {
            this.events.forEach(value => value(batch));
        });
    }

    public static onBatchUpdate(component: INetworkComponent, func: (batch: ICommunityArticleOptimizationBatchIncoming) => void) {
        this.events.push(func);
        component.onRemove(() => arrayRemove(this.events, func));
    }

    public static async create(outgoing: ICommunityArticleOptimizationBatchCreateOutgoing, component?: INetworkComponent): Promise<ICommunityArticleOptimizationBatchCreateIncoming> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/optimizationBatch`, outgoing, component);
        if (request && request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async getActive(communityId: string, component?: INetworkComponent): Promise<ICommunityArticleOptimizationBatchIncoming> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/article/optimizationBatch/active?communityId=${encodeURIComponent(communityId)}`, component);
        if (request && request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }

    public static async cancel(batchId: string, component?: INetworkComponent): Promise<ICommunityArticleOptimizationBatchIncoming> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/article/optimizationBatch/cancel/${batchId}`, {}, component);
        if (request && request.status == HttpStatus.OK) {
            return request.data;
        }
        return undefined;
    }
}
